import 'isomorphic-fetch';
import {RecallsAppModel} from '../typings/general';
import {processRecalls} from '../utils/general';
import {LocaleServiceV1} from '@volkswagen-onehub/locale-service';

interface FetchRecallOptions {
  readonly faServicesUrl: string;
  readonly vin: string;
  readonly localeService: LocaleServiceV1;
  readonly serviceConfigsServiceConfig?: string;
  readonly mockIds?: string;
  readonly mocksBaseUrl?: string;
}

function createRecallUrl(
  params: URLSearchParams,
  vin: string | undefined,
  urlOrigin: string
): string {
  console.log('Recalls request:::::::', vin, params, urlOrigin);
  //   params.set('sdlPath', `/vwsdl/rest/product/dealers/zip/${zip}.json`);
  // return ` https://test-fa-responses.s3.amazonaws.com/recalls-app/${vin}.json`;
  return `${urlOrigin}/recall?${params.toString()}`;
}

export class RecallFetchError extends Error {
  public constructor(message: string, public readonly url?: string) {
    super(message);
  }
}
export async function fetchRecall({
  localeService,
  faServicesUrl,
  serviceConfigsServiceConfig,
  mockIds,
  mocksBaseUrl,
  vin
}: FetchRecallOptions): Promise<RecallsAppModel> {
  const {language, countryCode, currency} = localeService;
  const params = new URLSearchParams({language, countryCode, currency});

  if (serviceConfigsServiceConfig) {
    params.set('serviceConfigsServiceConfig', serviceConfigsServiceConfig);
  }
  if (mockIds) {
    params.set('mockIds', mockIds);
  }

  if (mocksBaseUrl) {
    params.set('mocksBaseUrl', mocksBaseUrl);
  }
  params.set("vin", vin)
  const response = await fetch(createRecallUrl(params, vin, faServicesUrl));
  const recall = await response.json();

  if (response.status >= 400) {
    throw new RecallFetchError(recall.message, faServicesUrl);
  }
  return processRecalls(recall);
}
